export default __webpack_public_path__ + "resources/icons/d331-7648.webp";